import { ActivityUpdatePayload } from "@features/activities/activityTypes";
import { DropdownInputGroup, InputGroup, Submodule } from "@typedefs/modulesInterfaces";
import {
  ActivityFormFields,
  activityCost,
  activityTitle,
  capitalizationPhase,
  duration,
  dynamicOfChanges,
  climate,
  lastYearOfAccounting,
  moisture,
  startYear,
} from "./activityForm";

export const initValues: ActivityUpdatePayload = {
  id: 0,
  activity: {
    name: "",
    duration_t2: null,
    climate_t2: null,
    moisture_t2: null,
    soc_t2: null,
    start_year_t2: null,
    cost: null,
    change_rate: null,
  },
};

export { ActivityFormFields as EditActivityFields } from "./activityForm";

export const editActivity: Submodule = {
  name: "activity.introductory_activity_description",
  inputGroups: [
    activityTitle,
    startYear,
    duration,
    lastYearOfAccounting,
    dynamicOfChanges,
    climate,
    moisture,
    activityCost,
    capitalizationPhase,
  ],
};

export function isMoistureInput(input: InputGroup): input is DropdownInputGroup {
  return input.inputName === ActivityFormFields.moisture_t2
}
export function isClimateInput(input: InputGroup): input is DropdownInputGroup {
  return input.inputName === ActivityFormFields.climate_t2
}
